// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"4651de26","727":"eae8d62c","787":"7c855d1e"}[chunkId] + ".chunk.js";
};